export default __webpack_public_path__ + "static/th-c45c1e75e51c06c3d5ecb359f68f13c2.svg";